export const Nav = () => (
  <nav className="border-b border-[#1C2C4E] sticky top-0 bg-[#0A1628]/90 backdrop-blur z-50 px-6 py-4">
    <div className="max-w-6xl mx-auto flex items-center justify-between">
      <a href="/" data-testid="nav-brand-link" className="flex items-center gap-3">
        <svg className="w-7 h-7 text-[#51ADDA]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4 4h16v16H4zM9 9h6v6H9zM12 2v2M12 20v2M2 12h2M20 12h2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span className="font-display tracking-wider text-lg sm:text-xl uppercase text-white whitespace-nowrap">NEOELEC AUTO</span>
      </a>
      <div className="flex items-center gap-6">
        <a href="#services" data-testid="nav-services-link" className="hidden sm:inline text-xs uppercase tracking-[0.14em] text-slate-400 hover:text-white transition-colors">Services</a>
        <a href="#expedition" data-testid="nav-expedition-link" className="hidden sm:inline text-xs uppercase tracking-[0.14em] text-slate-400 hover:text-white transition-colors">Envoi France</a>
        <a href="/suivi" data-testid="nav-suivi-link" className="hidden md:inline text-xs uppercase tracking-[0.14em] text-slate-400 hover:text-white transition-colors">Suivi</a>
        <a href="#devis" data-testid="nav-devis-cta" className="text-[11px] sm:text-xs uppercase tracking-[0.14em] bg-[#EF3340] text-white font-bold px-3 sm:px-4 py-2 rounded hover:bg-[#f87171] transition-colors whitespace-nowrap">Demander un Devis</a>
      </div>
    </div>
  </nav>
);
